import { Paper, Box } from "@mui/material";

export default function ChronoConsole({ lines }) {
    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                borderRadius: "12px",
                height: 300,
                overflowY: "auto",
                bgcolor: "background.paper",
                mb: 3,
            }}
        >
            <Box
                sx={{
                    fontFamily: "ui-monospace, monospace",
                    fontSize: "0.85rem",
                }}
            >
                {lines.map((line, i) => (
                    <Box
                        key={i}
                        sx={{
                            py: 0.5,
                            borderBottom: "1px solid #e5e7eb",
                            color: "text.primary",
                        }}
                    >
                        {"> "}{line}
                    </Box>
                ))}
            </Box>
        </Paper>
    );
}
